import extractAllowedAttributes from '../helpers/extract-allowed-attributes';
import { get } from '../helpers/generator';

const generateCssFromHtml = async (html) => {
  if (!html) {
    throw new Error('HTML content are required.');
  }

  const attributes = extractAllowedAttributes(html);
  const content = attributes.map((attr) => `<div ${attr}></div>`).join('\n');
  const generator = get();
  if (!generator) {
    throw new Error('CSS Generator is not initialized.');
  }

  const uno = await generator;
  const result = await uno.generate(content);
  return result.getLayers(['default']);
};

export default generateCssFromHtml;
